<template>
    <v-snackbar v-model="visible" multi-line right :color="type">
        {{ message }}
    </v-snackbar>
</template>

<script>
export default {
    computed: {
        visible: {
            get() {
                return this.$store.state.snackbar.visible;
            },
            set(newValue) {
                this.$store.commit("hideSnackbar", newValue);
            },
        },

        type() {
            return this.$store.state.snackbar.type;
        },

        message() {
            return this.$store.state.snackbar.message;
        },
    },
};
</script>